export default __webpack_public_path__ + "static/media/MarcinBugaj.eea18e03.png";